import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import { TripProvider } from './context/TripProvider';
import CleverTapBootstrap from './components/clevertap/CleverTapBootstrap';
import KustomerBootstrap from './components/kustomer/KustomerBootstrap';

const stripePromise = loadStripe(process.env.REACT_APP_PK_STRIPE);

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (__, error) => {
        if (error?.status === 401 || error?.status === 1) return 0;
        return 1;
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CleverTapBootstrap />
        <KustomerBootstrap />
        <TripProvider>
          <Elements stripe={stripePromise}>
            <App />
          </Elements>
        </TripProvider>
      </AuthProvider>
    </QueryClientProvider>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();
